/**
 * @generated SignedSource<<c598d959cfb70c03d640fb9b1542bc86>>
 * @relayHash 3c5f395e0e159477aa2dc8644e0fb365
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81f25062a0ee13c06c22f5506e26fa5c9e4fb2b20911f0c99fbc240ded6cec23

import type { ConcreteRequest, Query } from 'relay-runtime';
export type blockServiceUserInfoQuery$variables = {
  accountId: string;
};
export type blockServiceUserInfoQuery$data = {
  readonly user: {
    readonly accountId: string;
    readonly avatarUrl: AGG$URL;
    readonly displayName: string;
  } | null | undefined;
};
export type blockServiceUserInfoQuery = {
  response: blockServiceUserInfoQuery$data;
  variables: blockServiceUserInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "alias": "displayName",
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "alias": "avatarUrl",
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "blockServiceUserInfoQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "blockServiceUserInfoQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3c5f395e0e159477aa2dc8644e0fb365",
    "id": "81f25062a0ee13c06c22f5506e26fa5c9e4fb2b20911f0c99fbc240ded6cec23",
    "metadata": {},
    "name": "blockServiceUserInfoQuery",
    "operationKind": "query",
    "text": "query blockServiceUserInfoQuery($accountId:ID!){user(accountId:$accountId){__typename,accountId,displayName:name,avatarUrl:picture,id}}"
  }
};
})();

(node as any).hash = "fc357d1266fb9ffaf6f640984aa37c6d";

export default node;
